export default {
  brandSub: "By Galano-Pacifico Law Firm & International Partners",
  nav: ["Rechtlicher Rahmen", "Institutioneller Vorsprung", "Schiedsverfahren", "Schiedsrichterpanel", "Preise & Governance", "Presse & Investoren"],
  initiate: "Schiedsverfahren Einleiten",
  portalLabel: "Mandantenportal",
  splash: {
    est: "Gegr. MMXXVI — Souveränes Tribunal",
    states: "172 Vertragsstaaten",
    copy: "Willkommen bei LexAegis International, dem weltweit führenden und angesehensten internationalen außergerichtlichen Schiedssystem. Wir erlassen autonome, rechtsverbindliche Schiedssprüche mit sofortiger Vollstreckungskraft in sämtlichen globalen Jurisdiktionen und verbinden technologische Effizienz mit strenger Einhaltung des internationalen Schiedsrechts.",
    enter: "Souveränes Register Betreten",
    convention: "New Yorker Übereinkommen 1958",
    auto: "Automatischer Eintritt läuft…",
  },
  hero: {
    overline: "Institutionelles Außergerichtliches Tribunal",
    l1: "Globale Juristische Exzellenz.",
    l2: "Sofortige Streitbeilegung.",
    sub: "Die führende Plattform für autoritative internationale Schiedsverfahren und Streitbeilegung mit sofortiger, verbindlicher Rechtskraft weltweit.",
    secondary: "Rechtlichen Rahmen Erkunden",
    stats: [
      { value: "172", label: "Staaten des NY-Übereinkommens", sub: "Vollstreckungsgarantie" },
      { value: "14 Tage", label: "Ø Schiedsspruch-Erteilung", sub: "statt 18 Monate vor Gericht" },
      { value: "100%", label: "eIDAS- & DSGVO-konform", sub: "Unveränderliches Digitales Register" },
      { value: "$4.8B+", label: "Entschiedene Ansprüche", sub: "Grenzüberschreitender Handel" },
    ],
  },
  marquee: [
    "Anerkannt nach NY-Übereinkommen 1958",
    "Konform mit UNCITRAL-Schiedsregeln",
    "eIDAS-Qualifizierter Elektronischer Zeitstempel",
    "ISO/IEC 27001:2022 Zertifizierte Sicherheit",
    "DSGVO Art. 32 Verschlüsseltes Register",
    "Grenzüberschreitende Bindende Vollstreckbarkeit",
    "Geführt von Galano-Pacifico & International Partners",
  ],
  framework: {
    overline: "Rechtlicher Rahmen",
    titleA: "Autorität, verankert im",
    titleB: "Völkerrecht",
    titleC: ", nicht in Versprechen.",
    body: "LexAegis operiert nicht im rechtsfreien Raum. Jede Verfahrensanordnung, jeder versiegelte Beweis und jeder endgültige Schiedsspruch ist darauf ausgelegt, die strengsten Anforderungen des internationalen Schiedsrechts zu erfüllen — damit die Entscheidung überall dort Bestand hat, wo sich Ihre Gegenseite befindet.",
    artLabel: "Anerkennung & Vollstreckung",
    pillars: [
      { title: "New Yorker Übereinkommen von 1958", body: "Schiedssprüche des LexAegis-Tribunals sind in allen 172 Vertragsstaaten anzuerkennen und vollstreckbar — ohne erneute Sachprüfung vor nationalen Gerichten." },
      { title: "UNCITRAL-Musterregeln", body: "Das Verfahren folgt den UNCITRAL-Schiedsregeln und garantiert rechtliches Gehör, Chancengleichheit der Parteien und volles Vertretungsrecht in jeder Phase." },
      { title: "Grenzüberschreitende Vollstreckung", body: "Zertifizierte Schiedssprüche werden direkt an Vollstreckungsregister, Gerichtsvollzieher-Netzwerke und diplomatische Rechtskanäle in der Jurisdiktion des Beklagten übermittelt." },
    ],
  },
  advantage: {
    overline: "Das LexAegis-Paradigma",
    titleA: "Zweistufige",
    titleB: "Gerichtliche Integrität",
    body: "Automatisierte Beweissichtung und asynchrone digitale Register beschleunigen das Verfahren — doch jede endgültige Entscheidung wird ausschließlich von akkreditierten menschlichen Schiedsrichtern, Juristen und ehemaligen Richtern getroffen. Technologie dient dem Recht; sie ersetzt niemals das Urteil.",
    guarantee: "Institutionelle Garantie",
    items: [
      { title: "KI-gestützte Jurisdiktionsprüfung", desc: "Automatischer Abgleich internationaler Verträge, Gerichtsstandsklauseln und Kollisionsnormen zur sofortigen Feststellung der prima-facie-Zuständigkeit.", badge: "Automatisierte Präzision" },
      { title: "Elite-Schiedspanel", desc: "Ehemalige Oberrichter, akkreditierte Schiedsrichter und spezialisierte internationale Juristen prüfen persönlich und erlassen die endgültigen verbindlichen Sprüche.", badge: "Menschliche Autorität" },
      { title: "Unveränderbarer eIDAS-Zeitstempel", desc: "Jede Beweiseinreichung, Klageschrift und Verfahrensanordnung wird kryptografisch mit gerichtsfesten Zeitstempeln versiegelt.", badge: "Beweissiegel" },
      { title: "Vollstreckung nach NY-Übereinkommen", desc: "Erlassene Schiedssprüche sind in 172 Vertragsstaaten unmittelbar vollstreckbar und umgehen staatliche gerichtliche Engpässe.", badge: "Globale Vollstreckung" },
    ],
  },
  workflow: {
    overline: "Manifest & Verfahren",
    titleA: "Das 4-Stufen-",
    titleB: "Schiedsprotokoll",
    side: "Von der Klageeinreichung bis zum verbindlichen, grenzüberschreitend vollstreckbaren Schiedsspruch — eine disziplinierte Verfahrenskette ohne Sackgassen.",
    note: "Verfahrenshinweis",
    steps: [
      { title: "Intelligentes Onboarding & Jurisdiktionsvalidierung", desc: "Die klagende Partei reicht Streitparameter und Schiedsklausel ein. Die automatisierten LexAegis-Systeme prüfen die Unterzeichnerbefugnis und Gerichtsstandseignung.", details: "Inklusive Streitwertrechner, Beklagtenbenachrichtigung und initialer Jurisdiktionsprüfung nach UNCITRAL-Regeln." },
      { title: "Sicheres Digitales Register & Versiegelte Schriftsätze", desc: "Die Parteien erhalten Zugang zu einer Ende-zu-Ende-verschlüsselten virtuellen Kammer. Beweise, Widerklagen und Schriftsätze werden nach eIDAS-Standards zeitgestempelt.", details: "Zero-Trust-Zugangskontrolle mit AES-256-Tresor und sofortigem multijurisdiktionalem Benachrichtigungssystem." },
      { title: "KI-Vorprüfung & Anhörung durch das Panel", desc: "Unsere Neural-Engine sichtet Präzedenzfälle und Vertragsklauseln, bevor das Register den zugewiesenen Senior-Schiedsrichtern übergeben wird.", details: "Durchgeführt per asynchroner digitaler Zeugenaussage oder optionalen verschlüsselten virtuellen Tribunalssitzungen." },
      { title: "Erlass des Endgültigen Bindenden Schiedsspruchs", desc: "Das Tribunal erlässt einen endgültigen, unanfechtbaren Schiedsspruch mit vollständiger rechtlicher Begründung, zertifiziert für die grenzüberschreitende Vollstreckung nach dem NY-Übereinkommen.", details: "Auf Wunsch direkte Übermittlung an lokale Gerichtsvollzieher und diplomatische Rechtsregister." },
    ],
  },
  panel: {
    overline: "Verifizierte Juristen",
    titleA: "Das",
    titleB: "Schiedsrichter-Register",
    body: "Unabhängige internationale Schiedsrichter, verpflichtet zu absoluter Unparteilichkeit und juristischer Präzision. Referenzen bei den ausstellenden Institutionen verifiziert.",
    verified: "Verifiziert",
    awards: "Schiedssprüche Erlassen",
    members: [
      { role: "Ehemalige Oberrichterin", spec: "Internationales Handels- & Seeschiedsrecht", jur: "London / Singapur — LCIA- & SIAC-akkreditiert" },
      { role: "Senior-Schiedsrichter & IP-Jurist", spec: "Grenzüberschreitende Technologie- & Patentstreitigkeiten", jur: "Genf / Zürich — WIPO-Neutraler" },
      { role: "Emeritierte Professorin für Völkerrecht", spec: "Staats- & Investitionsstreitigkeiten", jur: "Den Haag / Wien — ICSID-Panel-Mitglied" },
    ],
  },
  pricing: {
    overline: "Transparente Gebührenordnung",
    titleA: "Schiedsgebühren",
    titleB: "in Feststaffeln",
    body: "Keine versteckten Stundensätze. Transparente Verwaltungs- und Tribunalgebühren nach Gesamtstreitwert — volle Planbarkeit gegenüber klassischen Gerichtsverfahren.",
    calcLabel: "Streitwert (USD)",
    calcPlaceholder: "z. B. 480000",
    calcEmpty: "Eingeben, um Staffel zu finden",
    tierPrefix: "Staffel",
    matched: "Passend zu Ihrem Fall",
    mostRetained: "Am Häufigsten Gewählt",
    cta: "Unter dieser Staffel Einleiten",
    tiers: [
      { name: "Standard Commercial", range: "Ansprüche bis 250.000 USD", feeSuffix: "USD Fest", timeframe: "10-Tage-Schnellverfahren", features: ["Ernennung eines Einzelschiedsrichters", "Asynchrones Digitales Register", "KI-Vorprüfungs-Beweiszusammenfassung", "Zertifizierter NY-Schiedsspruch", "24/7 Verschlüsselter Portalzugang"] },
      { name: "Enterprise & Corporate", range: "Ansprüche 250.000 – 2.500.000 USD", feeSuffix: "USD Fest", timeframe: "14-tägige formale Entscheidung", features: ["Option 3-köpfiges Tribunal", "Prüfung Einstweiliger Verfügungen", "Priorisierte KI-Jurisdiktionsanalyse", "Virtueller Verhandlungssaal", "Direkte Grenzüberschreitende Zustellung", "Dedizierter Rechtsregistrator"] },
      { name: "Souverän & Komplex", range: "Ansprüche über 2.500.000 USD", feeSuffix: "Individuelle Gebührenordnung", timeframe: "Beschleunigter oder maßgeschneiderter Zeitplan", features: ["Individuelle Panelauswahl", "Multijurisdiktionale Konfliktlösung", "Maßgeschneiderte Vertraulichkeitsprotokolle", "Diplomatische Vollstreckungsunterstützung", "Concierge-Rechtsbetriebsteam"] },
    ],
  },
  intake: {
    channel: "AES-256-Verschlüsselter Kanal",
    title: "Schiedsverfahren Einleiten",
    desc: "Füllen Sie das Formular aus, um eine formelle Schiedsklage im souveränen Register einzureichen.",
    claimant: "Klagende Partei / Vollständiger Name",
    respondent: "Beklagte Partei / Vollständiger Name",
    claimValue: "Geschätzter Streitwert (USD)",
    jurisdiction: "Anwendbares Recht / Gerichtsstand",
    email: "Kontakt-E-Mail für Bestätigungen",
    summary: "Streitbeschreibung & Schiedsklausel",
    phClaimant: "z. B. Meridian Trading S.A.",
    phRespondent: "z. B. Novatek Logistics GmbH",
    phClaim: "480000",
    phSummary: "Beschreiben Sie den Streit und zitieren Sie die Schiedsklausel (z. B. Klausel 14.2 des Rahmenliefervertrags)…",
    submit: "Schrift Einreichen & Aktenzeichen Generieren",
    submitting: "Register wird Versiegelt…",
    footnote: "Einreichung DSGVO Art. 32 konform · eIDAS-zeitgestempelt · Vertraulich",
    successTitle: "Eingereicht — Aktenzeichen {ref}",
    successBody: "Ihre Schiedsklage wurde im sicheren Register hinterlegt. Ein LexAegis-Registrator meldet sich innerhalb eines Werktages.",
    errorTitle: "Einreichung abgelehnt",
    errorBody: "Bitte prüfen Sie alle Felder und reichen Sie erneut ein.",
  },
  portal: {
    tag: "2FA-Gesichert · ISO 27001",
    title: "Sicheres Schiedsrichterportal",
    email: "Registrierte E-Mail",
    password: "Passwort",
    token: "Hardware-Token-Code (6-stellig)",
    submit: "Sicher Authentifizieren",
    verifying: "Zugangsdaten werden geprüft…",
    welcome: "Authentifizierte Sitzung",
    dockets: "Eingereichte Schiedsakten",
    inquiries: "Presse- & Investorenanfragen",
    logout: "Abmelden",
    empty: "Noch keine Einträge im Register.",
    errorInvalid: "Ungültige Zugangsdaten oder gesperrtes Konto. Bitte prüfen und erneut versuchen.",
    statusLabel: "Status",
    statusLabels: ["Eingereicht", "In Prüfung", "Anhörungstermin", "Schiedsspruch Erlassen"],
    downloadPdf: "PDF Exportieren",
    updated: "Status aktualisiert",
    footnote: "Zugang nur für bestellte Schiedsrichter & registrierte Anwälte",
    toastTitle: "Demonstrationsportal",
    toastBody: "Zugangsdaten für Schiedsrichter und Anwälte werden ausschließlich vom Registerbüro von Galano-Pacifico vergeben. Diese Vorschau gewährt keinen Registerzugang.",
  },
  press: {
    overline: "Presse- & Investor Relations",
    titleA: "Presse- &",
    titleB: "Investorenbüro",
    body: "Akkreditierte Journalisten und institutionelle Investoren erreichen das Kommunikationsbüro von LexAegis über diesen verschlüsselten Kanal. Alle Anfragen werden streng vertraulich vom Public-Affairs-Büro von Galano-Pacifico bearbeitet.",
    secureNote: "PGP-verschlüsselter Kanal · Antwort innerhalb von 24 Stunden",
    fullName: "Vollständiger Name",
    org: "Medienhaus / Investmentgesellschaft",
    email: "Berufliche E-Mail",
    type: "Art der Anfrage",
    message: "Nachricht",
    types: ["Pressekit-Anfrage", "Medieninterview", "Investor-Relations-Briefing", "Finanzüberblick"],
    phName: "z. B. Alexandra Reyes",
    phOrg: "z. B. Financial Times / Meridian Capital",
    phMessage: "Beschreiben Sie Ihr Anliegen, die Frist und das gewünschte Senioritätslevel des Sprechers…",
    submit: "Sichere Anfrage Senden",
    downloadKit: "Pressekit Herunterladen (PDF)",
    again: "Weitere Anfrage Senden",
    submitting: "Verschlüsselung & Übermittlung…",
    footnote: "Anfragen sind vertraulich, DSGVO Art. 32 konform und werden niemals an Dritte weitergegeben.",
    successTitle: "Anfrage Erhalten — Aktenzeichen {ref}",
    successBody: "Ihre Anfrage wurde beim Kommunikationsbüro registriert. Antwort innerhalb von 24 Stunden.",
    errorTitle: "Übermittlung abgelehnt",
    errorBody: "Bitte prüfen Sie alle Felder und senden Sie erneut.",
  },
  footer: {
    compliance: "Betrieben strikt nach internationalen Handelsschiedsstatuten, dem Übereinkommen von 1958 über die Anerkennung und Vollstreckung ausländischer Schiedssprüche und den UNCITRAL-Regeln. Alle Registerdaten werden nach Art. 32 DSGVO mit AES-256 im Ruhezustand und bei Übertragung verschlüsselt verarbeitet.",
    institutional: "Institutionelles",
    links: ["Verfahrensregeln", "Ethischer Kodex", "Schiedsrichterpanel", "Gebühren & Rechner", "Institutioneller Vorsprung", "Presse- & Investorenbüro"],
    secureTitle: "Sicherer Zugang",
    secureBody: "Bestellte Schiedsrichter und registrierte Anwälte greifen über das gehärtete Portal auf versiegelte Register zu.",
    portalBtn: "Sicheres Schiedsrichterportal",
    ethics: "Berufsethischer Kodex: Jeder bestellte Jurist ist an die IBA-Richtlinien zu Interessenkonflikten in internationalen Schiedsverfahren gebunden.",
    copyright: "© 2026 LexAegis International — By Galano-Pacifico Law Firm & International Partners. Alle Rechte vorbehalten.",
    sovereign: "Souveränes Außergerichtliches Tribunal",
  },
};
